import { useGlobalContext } from '@honeycomb/data';
import { Paper } from '@honeycomb/ui-core';
import React from 'react';
export function OccupancyHelpMessage() {
    const { resourceStrings: { HC_GROUP_BOOKINGS_PROMPT }, } = useGlobalContext();
    return (React.createElement(Paper, { radius: "s", py: 2, px: 3, border: 0 }, HC_GROUP_BOOKINGS_PROMPT));
}
